import DominanceView from "@/components/dominance/DominanceView.vue";
import ScoreView from "@/components/score/ScoreView.vue";
import PriceVolume from "@/components/analysis/PriceVolume.vue"
import TechnicalIndicator from "@/components/indicator/TechnicalIndicator.vue"
import AIBrief from "@/components/brief/AIBrief.vue"
import MainTradingView from "@/components/trading/index.vue"

const routes = [
  // 처음 페이지 접속시 로딩되는 페이지
  { path: "/", redirect: "/dominance" },
  // 도미넌스 페이지
  {
    path: "/dominance",
    name: "DominanceView",
    component: DominanceView,
    props: true,
  },
  // 스코어 페이지
  {
    path: "/score",
    name: "ScoreView",
    component: ScoreView,
    props: true,
  },
  // 브리핑 페이지
  {
    path: "/brief",
    name: "AIBrief",
    component: AIBrief,
    props: true,
  },
  // 거래량 & 가격 페이지
  {
    path: "/volume",
    name: "PriceVolume",
    component: PriceVolume,
    props: true,
  },
  // 보조지표 라우터
  {
    path: "/indicator",
    name: "TechnicalIndicator",
    component: TechnicalIndicator,
    props: true,
  },
  {
    path: "/trading",
    name: "MainTradingView",
    component: MainTradingView,
    props: true,
  },
  {
    path: "/trading-chart",
    name: "TradingChartView",
    component: MainTradingView,
    props: true,
  },
  // {
  //   path: "/trading-test",
  //   name: "TestTrading",
  //   component: MainTradingView,
  //   props: true,
  // },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/dominance",
  },

];

export default routes;
